export type ExperimentEntry = [string, App.OptimizelyExperimentDetails]
export type FeatureFlagEntry = [string, boolean]

/**
 * Formats the experiment title
 * @returns The title by replacing '_' with spaces and capitalising each word e.g. 'multi_item_cart' to 'Multi Item Cart'
 */
export function formatOptimizelyTitle(experimentId: string): string {
  const experimentIdList = experimentId.split('_')
  if (experimentIdList.length === 0) {
    return ''
  }
  return experimentIdList
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ')
}

export function filterOptimizelyEntry(query: string) {
  return ([itemId]: ExperimentEntry | FeatureFlagEntry) => {
    const itemName = formatOptimizelyTitle(itemId)
    return (itemId.toLowerCase().includes(query.toLowerCase()) || itemName.toLowerCase().includes(query.toLowerCase()))
  }
}
